<template lang="pug">
    div
        .subheading Monto:
        v-text-field.title(
                :mask="mixCurrencyMask(payRollDeductionPayment, 12)"
                placeholder="Ingrese monto descuento por planilla"
                prefix="$"
                v-model="payRollDeductionPayment"
                :rules='[rules.required, rules.validPayment]'
                @input="setPayment(payRollDeductionPayment)")
        .subheading N° de Cuotas
        v-text-field.headline(solo
            mask="##"
            placeholder="Ingrese n° de coutas"
            v-model="creditInstallments"
            :rules='[rules.required]' validate-on-blur)
</template>

<script>
import CurrencyUtils from '@/mixins/CurrencyUtils'
import {mapState, mapGetters, mapActions} from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function(){
        return {
            payRollDeductionPayment :'',
            creditInstallments :1,
            rules:{ // Después mover esto a un mixin
                required: value => !!value || 'Debe ingresar un valor.',
                validPayment: value => parseInt(value) <= this.totalToPay || 'Pago no puede ser mayor que el total',
            }
            
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            //payment: state => state.payment,
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),
        allPayRollDeductionDataSet: function(){
            return this.payRollDeductionPayment != '' && parseInt(this.payRollDeductionPayment) <= this.totalToPay
        },

    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail'
        }),
    },
    watch: {
        allPayRollDeductionDataSet: function(newVal, oldVal){
            if(newVal){
                this.setPayment(this.payRollDeductionPayment)
                let payload = {
                    creditInstallments: this.creditInstallments
                }
                this.setPaymentDetail(payload)
            }else{
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },

        paymentMethod: function(newVal, oldVal){
            //console.log(newVal)
            this.creditInstallments = ''
            this.payRollDeductionPayment = this.totalToPay.toString()
        },
        creditInstallments: function (newVal , oldVal){
            let payload = {
                creditInstallments: newVal
            }
            this.setPaymentDetail(payload)
        }
    },
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>